import { Tooltip } from "@swiggy-private/core-ui";
import styled from "styled-components";

export const TooltipContainer = styled(Tooltip)`
    position: absolute;
    bottom: 100%;
    left: 0;
    margin-bottom: ${(props) => props.theme.spacing.xxSmall};
    z-index: 1;
    color: ${(props) => props.theme.colors[props.theme.colorMode].text_inverse_Highest_Emphasis};
    border-radius: ${(props) => props.theme.cornerRadius.medium};
    display: flex;
    gap: ${(props) => props.theme.spacing.xxSmall};
`;
